import React from "react";
import SingleImage from "../Gallaryprops";
// 2017
import Img12 from "../../../atrimages/pervious event images atri/2017/12.jpg";
import Img11 from "../../../atrimages/pervious event images atri/2017/11.jpg";
import Img10 from "../../../atrimages/pervious event images atri/2017/10.jpg";
import Img9 from "../../../atrimages/pervious event images atri/2017/9.jpg";
import Img8 from "../../../atrimages/pervious event images atri/2017/8.jpg";
import Img7 from "../../../atrimages/pervious event images atri/2017/7.jpg";
import Img6 from "../../../atrimages/pervious event images atri/2017/6.jpg";
import Img5 from "../../../atrimages/pervious event images atri/2017/5.jpg";
import Img4 from "../../../atrimages/pervious event images atri/2017/4.jpg";
import Img3 from "../../../atrimages/pervious event images atri/2017/3.jpg";
import Img2 from "../../../atrimages/pervious event images atri/2017/2.jpg";
import Img1 from "../../../atrimages/pervious event images atri/2017/1.jpg";

export default function Borealis17() {
  return (
    <div className="YearWise">
      <div className="2017">
        <h2>GLIMPSE OF BOREALIS - 2017</h2>
        <SingleImage gimage={Img3} title="President" />
        <SingleImage gimage={Img6} title="President" />
        <SingleImage gimage={Img7} title="President" />
        <SingleImage gimage={Img9} title="President" />
        <SingleImage gimage={Img8} title="President" />
        <SingleImage gimage={Img11} title="President" />
        <SingleImage gimage={Img10} title="President" />
        <SingleImage gimage={Img5} title="President" />
        <SingleImage gimage={Img4} title="President" />
        <SingleImage gimage={Img12} title="President" />
        <SingleImage gimage={Img2} title="President" />
        <SingleImage gimage={Img1} title="President" />
      </div>
      <br />
      <br />
    </div>
  );
}
